angular.module('eatself').directive('onErrorSrc', function() {
	// on-error-src: alternate image if src not found
	// on-error-class: class to add if usin alternate image
	// on-error-parent-selector: add class to parent element as well
	return {
		scope: {},
		link: function($scope, $element, $attrs) {
			$element.one('error',(ev)=>{
				$element.attr('src', $attrs.onErrorSrc || "dist/assets/no-img.png");
				$element.addClass($attrs.onErrorClass);
				if ($attrs.onErrorParentSelector) {
					$element.parents($attrs.onErrorParentSelector).addClass($attrs.onErrorClass)
				}
			})
		}
	};
})
